module.exports = __webpack_public_path__ + "img/logo1.8a71c203.jpg";